import { SVGProps } from 'react';

const DirectionArrow = ({
  width = 21,
  height = 20,
  fill = '#00AEC7',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 20"
    {...otherProps}>
    <path fillRule="evenodd" clipRule="evenodd" d="M9.57775 0.0996094L10.546 1.06785L2.61384 9L20.86 9V10.3L2.55887 10.3L10.3897 18.1309L9.42149 19.0991L0.00232426 9.67994L0.00245341 9.67981L0 9.67736L9.57775 0.0996094Z" fill={fill} />
  </svg>
);

export default DirectionArrow;
